import { Pipe, PipeTransform } from '@angular/core';
import { LoadingService } from '../services';
import { Observable } from 'rxjs';

export function getLoadingTag(tag: string, id: string) {
  return `${tag}-${id}`;
}

@Pipe({
  name: 'isLoadingById',
})
export class IsLoadingByIdPipe implements PipeTransform {
  constructor(private readonly loadingService: LoadingService) {
  }
  transform(tag: string, id: string): Observable<boolean> {
    return this.loadingService.getIsLoading(getLoadingTag(tag, id));
  }
}
